import React from 'react'
import { useNavigate } from 'react-router-dom'

const QuicklinkComponent = () => {
  const navigate = useNavigate()

  const QuicklinkButton = ({ path, selectTab, src, srcType = 'png', label }) => {
    return (
      <button
        type="button"
        className="relative w-full flex flex-col justify-center items-center "
        onClick={() => {
          navigate(path)

          if (selectTab) {
            window.localStorage.setItem('toon_default_tab', selectTab)
          }
        }}
      >
        <img
          src={`/images/toon/quicklink/mainQuicklink_${src}.${srcType}`}
          className={srcType === 'gif' ? 'w-[18vw] h-[18vw] object-cover' : 'w-[14vw] h-[14vw]'}
          alt=""
        />
        <div className="absolute -bottom-[5vw] text-[3vw]">{label}</div>
      </button>
    )
  }

  return (
    <div className="w-full px-[2vw] py-[4vw] flex flex-row justify-between">
      <QuicklinkButton path="/toon" selectTab="daily" src="daily" label="요일연재" />
      <QuicklinkButton path="/toon" selectTab="recommend" src="recommend" label="완결작품" />
      <QuicklinkButton path="/novel" src="novel" label="웹소설" />
      <QuicklinkButton path="/mission" src="coin" label="무료코인" />
      <QuicklinkButton path="/event-list" src="event" label="이벤트" />
    </div>
  )
}
export default QuicklinkComponent
